exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-menu {\n  width: 50px;\n  background: #ffffff;\n  padding: 24px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  border-left: 8px solid #D7D7DE;\n}\n.right-menu .button-area span:not(:last-of-type) {\n  margin-bottom: 24px !important;\n}\n.right-menu .button-area span.red {\n  color: red;\n}\n.right-menu .button-area span.disabled {\n  color: lightgray;\n}\n.project_action_modal .ni-form-item-label {\n  padding-top: 8px;\n}\n", ""]);

// exports
